// import { MDBContainer } from "mdbreact";
import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { FaFloppyDisk } from "react-icons/fa6";
import axios from "axios";
import { Button } from "evergreen-ui";

function FormRegisterB() {
  // const [TypeStd1, setTypeStd1] = useState("");
  // const [Fac1, setFac1] = useState("");
  // const [Maj1, setMaj1] = useState("");
  // const [TypeStd2, setTypeStd2] = useState("");
  // const [Fac2, setFac2] = useState("");
  // const [Maj2, setMaj2] = useState("");
  const [InputRegist, setInputRegist] = useState({
    level: "",
    plan: "",
    vga: "",
    typestd: "",
    typestd2: "",
    faculty: "",
    faculty2: "",
    majorid: "",
    majorid2: "",
  });
  const [DataFac1, setDataFac1] = useState([]);
  const [DataFac2, setDataFac2] = useState([]);
  const [DataMaj1, setDataMaj1] = useState([]);
  const [DataMaj2, setDataMaj2] = useState([]);
  const [openb, setopenb] = useState(true);
  const [ListTypeStudent, setListTypeStudent] = useState([]);
  let headers = new Headers({
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Basic ${localStorage.getItem("token")}`,
  });
  useEffect(() => {
    const type = localStorage.getItem("typestudent");
    if (type === "3") {
    } else if (type === "4") {
    }
    GetTypeStudent(type).then((res) => {
      setListTypeStudent(res);
    });
    //  console.log(object)
  }, []);
  const GetTypeStudent = async (type) => {
    try {
      const fetch = await axios.get(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showtype/" + type
      );
      const data = fetch.data.data.data;
      return data;
    } catch (error) { }
  };
  const [Chkkb, setChkkb] = useState("");
  // const onChangeRegist = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   if (name === "majorid") {
  //     const expl = value.split(",");
  //     const mid = expl[0];
  //     setChkkb(expl[1]);
  //     setInputRegist((values) => ({ ...values, [name]: mid }));
  //   } else {
  //     setInputRegist((values) => ({ ...values, [name]: value }));
  //   }
  //   // setTypeStd1(e.target.value);
  // };
  const onChangeFac1 = async (e) => {
    try {
      setDataMaj1([]);
      setDataMaj2([]);
      setDataFac2([]);
      setChkkb("");
      setInputRegist((values) => ({ ...values, majorid: "" }));
      const name = e.target.name;
      const value = e.target.value;
      setInputRegist((values) => ({ ...values, [name]: value }));
      let bodydata = {
        typestudent: localStorage.getItem("typestudent"),
        level: localStorage.getItem("level"),
        plan: localStorage.getItem("plan"),
        vga: localStorage.getItem("vga"),
        typestd: InputRegist.typestd,
        level_saka: "1",
        faculty: value,
        faculty2: "",
        faculty3: "",
        saka1: "",
        saka2: "",
        saka3: "",
        courseyear: "1",
      };
      const fetch = await axios.post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showsaka",
        bodydata,
        { headers: headers }
      );
      const data = await fetch.data.data.data;
      if (data.length !== 0) {
        let i = 0;
        while (i < data.length) {
          if (data[i].LEVEL_OPEN_NAME === null) {
            data[i].LEVEL_OPEN_NAME = data[i].LEVEL_NAME;
          }
          i++;
        }
        const options2 = data.map((d) => ({
          value: d.MAJOR_ID + "," + d.LEVEL_NAME + "," + d.MAJOR_NAME,
          label: d.MAJOR_NAME + " (" + d.LEVEL_OPEN_NAME + ")",
        }));
        console.log(options2);
        setDataMaj1(options2);
      }
      console.log(data);
    } catch (error) { }
  };
  const onChangeFac2 = async (e) => {
    try {
      setDataMaj2([]);
      setInputRegist((values) => ({ ...values, majorid2: "" }));
      // setChkkb("")
      const name = e.target.name;
      const value = e.target.value;
      setInputRegist((values) => ({ ...values, [name]: value }));
      console.log(value);
      let bodydata = {
        typestudent: localStorage.getItem("typestudent"),
        level: localStorage.getItem("level"),
        plan: localStorage.getItem("plan"),
        vga: localStorage.getItem("vga"),
        typestd: InputRegist.typestd2,
        level_saka: "1",
        faculty: InputRegist.faculty,
        faculty2: value,
        faculty3: "",
        saka1: InputRegist.majorid,
        saka2: "",
        saka3: "",
        courseyear: "1",
      };
      const fetch = await axios.post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showsaka",
        bodydata,
        { headers: headers }
      );
      const data = await fetch.data.data.data;
      if (data.length !== 0) {
        let datama = [];
        let i = 0;
        while (i < data.length) {
          if (data[i].LEVEL_OPEN_NAME === null) {
            data[i].LEVEL_OPEN_NAME = data[i].LEVEL_NAME;
          }
          i++;
        }
        data.forEach((f) => {
          if (
            f.LEVEL_NAME !== "ครุศาสตรบัณฑิต" &&
            f.MAJOR_ID !== "1110" &&
            f.MAJOR_ID !== "1304" &&
            f.MAJOR_ID !== "1310" &&
            f.MAJOR_ID !== "1106"
            // f.MAJOR_ID !== "1304" &&
            // f.MAJOR_ID !== "1310"
          ) {
            if (localStorage.getItem("plan") === "1") {
              // if (f.MAJOR_ID === "1106") {
              datama.push({
                value: f.MAJOR_ID + "," + f.LEVEL_NAME + "," + f.MAJOR_NAME,
                label: f.MAJOR_NAME + " (" + f.LEVEL_OPEN_NAME + ")",
              });
              // }
            } else if (localStorage.getItem("plan") !== "1") {
              // if (f.MAJOR_ID !== "1106") {
              datama.push({
                value: f.MAJOR_ID + "," + f.LEVEL_NAME + "," + f.MAJOR_NAME,
                label: f.MAJOR_NAME + " (" + f.LEVEL_OPEN_NAME + ")",
              });
              // }
            }
          }
        });
        // const options2 = data.map((d) => ({
        //   value: d.MAJOR_ID + "," + d.LEVEL_NAME + "," + d.MAJOR_NAME,
        //   label: d.MAJOR_NAME + " (" + d.LEVEL_OPEN_NAME + ")",
        // }));
        console.log(datama, "datamajor2");
        setDataMaj2(datama);
      }
    } catch (error) { }
  };
  const onChangeMaj1 = async (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const expl = value.split(",");
      setDataMaj2([]);
      setInputRegist((values) => ({ ...values, majorid2: "" }));
      setChkkb(expl[1]);
      setInputRegist((values) => ({ ...values, [name]: expl[0] }));
      localStorage.setItem("majorid", expl[0]);
      // const fetch = await axios.post();
    } catch (error) { }
  };

  const onChangeMaj2 = async (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const expl = value.split(",");

      // setChkkb(expl[1]);
      setInputRegist((values) => ({ ...values, [name]: expl[0] }));
    } catch (error) { }
  };

  const onChangeStystd1 = async (e) => {
    try {
      setDataFac1([]);
      setDataMaj1([]);
      setChkkb("");
      const name = e.target.name;
      const value = e.target.value;
      setInputRegist((values) => ({ ...values, [name]: value }));
      let bodydata = {
        typestudent: localStorage.getItem("typestudent"),
        level: localStorage.getItem("level"),
        plan: localStorage.getItem("plan"),
        vga: localStorage.getItem("vga"),
        typestd: e.target.value,
        level_saka: "1",
        faculty: "",
        faculty2: "",
        faculty3: "",
        courseyear: "1",
      };
      const fetch = await axios.post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showfaculty",
        bodydata,
        { headers: headers }
      );
      const data = fetch.data.data.data;
      console.log(data);
      const options = data.map((d) => ({
        value: d.id_fac,
        label: d.faculty_name,
      }));
      console.log(options)
      setDataFac1(options);
    } catch (error) { }
  };
  const onChangeStystd2 = async (e) => {
    try {
      setDataFac2([]);
      setDataMaj2([]);
      // setChkkb("")
      const name = e.target.name;
      const value = e.target.value;
      setInputRegist((values) => ({ ...values, [name]: value }));
      let bodydata = {
        typestudent: localStorage.getItem("typestudent"),
        level: localStorage.getItem("level"),
        plan: localStorage.getItem("plan"),
        vga: localStorage.getItem("vga"),
        typestd: e.target.value,
        level_saka: "2",
        faculty: "",
        faculty2: "",
        faculty3: "",
        courseyear: "1",
      };
      const fetch = await axios.post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showfaculty",
        bodydata,
        { headers: headers }
      );
      const data = fetch.data.data.data;

      const options = data.map((d) => ({
        value: d.id_fac,
        label: d.faculty_name,
      }));
      console.log(options, "type2");
      setDataFac2(options);
    } catch (error) { }
  };

  const [IsLoading, setIsLoading] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    localStorage.setItem("typestd", InputRegist.typestd);
    localStorage.setItem("typestd2", InputRegist.typestd2);
    localStorage.setItem("typestd3", "");
    localStorage.setItem("faculty", InputRegist.faculty);
    localStorage.setItem("faculty2", InputRegist.faculty2);
    localStorage.setItem("faculty3", "");
    localStorage.setItem("majorid", InputRegist.majorid);
    localStorage.setItem("majorid2", InputRegist.majorid2);
    localStorage.setItem("majorid3", "");
    setTimeout(() => { }, 3500);
    setIsLoading(false);
    // console.log(InputRegist)
    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
  };

  return (
    <div className="d-flex  justify-content-center">
      <MetaTags>
        <title>ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
        <meta
          name="description"
          content="ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
        />
        <meta property="og:title" content="ข้อมูลสาขาที่สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
        <meta property="og:image" content="../../public/favicon.ico" />
      </MetaTags>
      <div className="container-lg ">
        <form
          onSubmit={onSubmit}
          className="pt-3  justify-content-center d-flex flex-column "
          style={{ gap: "15px" }}
        >
          {localStorage.getItem("typestudent") === "1" ? (
            <>
              <h4 className="text-white  p-2" style={{ backgroundColor: "#515052" }}>
                สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร
              </h4>
            </>
          ) : (
            <>
              {localStorage.getItem("typestudent") === "2" ? (
                <>
                  <h4 className="text-white  p-2" style={{ backgroundColor: "#515052" }}>
                    สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร
                  </h4>
                </>
              ) : (
                <>
                  {localStorage.getItem("typestudent") === "3" ? (
                    <>
                      <h4 className="text-white  p-2" style={{ backgroundColor: "#515052" }}>
                        สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร
                      </h4>
                    </>
                  ) : (
                    <>
                      {localStorage.getItem("typestudent") === "4" ? (
                        <>
                          <h4 className="text-white  p-2" style={{ backgroundColor: "#515052" }}>
                            สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร
                          </h4>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("typestudent") === "5" ? (
                            <>
                              <h4
                                className="text-white  p-2"
                                style={{ backgroundColor: "#515052" }}
                              >
                                สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชา/วิชาเอกชีพครู
                                มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </h4>
                            </>
                          ) : (
                            <>
                              {localStorage.getItem("typestudent") === "6" ? (
                                <>
                                  <h4
                                    className="text-white  p-2"
                                    style={{ backgroundColor: "#515052" }}
                                  >
                                    สมัครเรียนประกาศนียบัตรผู้ช่วยพยาบาล มหาวิทยาลัยราชภัฏกำแพงเพชร
                                  </h4>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
          {localStorage.getItem("typestudent") === "1" ? (
            <div>
              <div
                className="p-2 "
                style={{
                  fontWeight: "500",
                  backgroundColor: "#caf0f8",
                  color: "#007ea7",
                }}
              >
                เลือกสาขาวิชา{" "}
                <span style={{ fontWeight: "400", fontSize: "14px" }}>
                  &nbsp;{" "}
                  {localStorage.getItem("robId") === "148"
                    ? ""
                    : // "ลำดับ 1 ( กรณีวุฒิครุศาสตรบัณฑิตเลือกได้ 2 สาขาวิชา )"} </span>
                    ""}{" "}
                </span>
              </div>
              <div className=" p-3 m-0  row col-12" style={{ boxShadow: "0px 0px 6px  #00000020" }}>
                <div className="col-md-4">
                  <label htmlFor="select-mj1" className="form-label">
                    ประเภทนักศึกษา
                  </label>
                  <select
                    name="typestd"
                    id="select-mj1"
                    className="form-control"
                    onChange={onChangeStystd1}
                  >
                    <option>---เลือกประเภทนักศึกษา---</option>
                    {Array.isArray(ListTypeStudent) &&
                      ListTypeStudent.map((item, key) =>
                        localStorage.getItem("robId") === "148" ? (
                          <>
                            {item.type_std_id === "1" ? (
                              <>
                                <option key={key} value={item.type_std_id}>
                                  ภาค {item.type_std_name}
                                </option>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <option key={key} value={item.type_std_id}>
                            ภาค {item.type_std_name}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="select-mj1" className="form-label">
                    คณะ
                  </label>
                  <select
                    value={InputRegist.faculty}
                    id="select-mj1"
                    className="form-control"
                    onChange={onChangeFac1}
                    name="faculty"
                    required
                  >
                    <option>---เลือกคณะที่ต้องการ---</option>
                    {Array.isArray(DataFac1) &&
                      DataFac1.map((item, key) =>
                        item.value !== "8" ? (
                          <>
                            {localStorage.getItem("robId") === "182" &&
                              (item.value === "2" || item.value === "1") ? (
                              <>
                                <option key={key} value={item.value}>
                                  {item.label}
                                </option>
                              </>
                            ) : (
                              <>
                                {localStorage.getItem("robId") === "182" ? (
                                  // {localStorage.getItem("robId") === "152" && item.value !== "2" ? (
                                  <>
                                    {" "}
                                    {localStorage.getItem("level") === "12" ? (
                                      <>
                                        {item.value !== "2" ? (
                                          <>
                                            <option key={key} value={item.value}>
                                              {item.label}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            {/* <option key={key} value={item.value}>
                                              {item.label}
                                            </option> */}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <option key={key} value={item.value}>
                                        {item.label}
                                      </option>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                          { localStorage.getItem("robId") === "186" ? (
                            <option key={key} value={item.value}>
                                        {item.label}
                                      </option>
                         
                          ) : (<></>)
                          }
                         </> 
                        )
                      )}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="select-mj1" className="form-label">
                    สาขาวิชา/วิชาเอก
                  </label>
                  <select
                    id="select-mj1"
                    className="form-control"
                    onChange={onChangeMaj1}
                    name="majorid"
                  >
                    <option>---เลือกสาขาวิชา---</option>
                    {Array.isArray(DataMaj1) &&
                      DataMaj1.map((i, key) =>
                        InputRegist.faculty === "2" && localStorage.getItem("robId") === "176" ? (
                          <>
                            {/* {i.value.split(",")[0] !== "1110" ? (
                              <>
                                <option key={key} value={i.value}>
                                  {i.label}
                                </option>
                              </>
                            ) : (
                              <></>
                            )} */}
                            <option key={key} value={i.value}>
                              {i.label} (
                              {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                ? i.value.split(",")[1]
                                : ""}
                              )
                            </option>
                          </>
                        ) : InputRegist.faculty === "1" ? (
                          // ) : InputRegist.faculty === "1" && i.value.split(",")[0] === "1110" ? (
                          <>
                            {localStorage.getItem("level") === "12" ? (
                              <>
                                {i.value.split(",")[1] !== "ครุศาสตรบัณฑิต" ? (
                                  <>
                                    <option key={key} value={i.value}>
                                      {i.label} (
                                      {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                        ? i.value.split(",")[1]
                                        : ""}
                                      )
                                    </option>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <>
                                <option key={key} value={i.value}>
                                  {i.label} (
                                  {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                    ? i.value.split(",")[1]
                                    : ""}
                                  )
                                </option>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {localStorage.getItem("level") === "12" ? (
                              <>
                                {i.value.split(",")[1] !== "ครุศาสตรบัณฑิต" ? (
                                  <>
                                    <option key={key} value={i.value}>
                                      {i.label} (
                                      {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                        ? i.value.split(",")[1]
                                        : ""}
                                      )
                                    </option>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <>
                                <option key={key} value={i.value}>
                                  {i.label} (
                                  {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                    ? i.value.split(",")[1]
                                    : ""}
                                  )
                                </option>
                              </>
                            )}
                          </>
                        )
                      )}
                  </select>
                </div>
              </div>
              {/* <hr/> */}
              {(InputRegist.faculty === "2" ||
                InputRegist.majorid === "1110" ||
                InputRegist.majorid === "1310" ||
                InputRegist.majorid === "1304" ||
                (InputRegist.faculty === "3" &&
                  (InputRegist.majorid === "1301" || InputRegist.majorid === "1302")) ||
                (InputRegist.faculty === "1" &&
                  (InputRegist.majorid === "1101" ||
                    InputRegist.majorid === "1110" ||
                    InputRegist.majorid === "1102" ||
                    InputRegist.majorid === "1103" ||
                    InputRegist.majorid === "1110" ||
                    InputRegist.majorid === "1106"))) && openb === true ? (
                <>
                  <div
                    className="p-2"
                    style={{
                      fontWeight: "500",
                      backgroundColor: "#f2ebfb",
                      color: "#757bc8",
                      marginTop: "20px",
                    }}
                  >
                    เลือกสาขาวิชาลำดับ 2
                  </div>
                  <div className=" p-3 m-0  row " style={{ boxShadow: "0px 0px 6px  #00000020" }}>
                    <div className="col-md-4">
                      <label htmlFor="select-mj1" className="form-label">
                        ประเภทนักศึกษา
                      </label>
                      <select
                        id="select-mj1"
                        className="form-control"
                        name="typestd2"
                        onChange={onChangeStystd2}
                      >
                        <option>---เลือกประเภทนักศึกษา---</option>
                        {Array.isArray(ListTypeStudent) &&
                          ListTypeStudent.map((i, key) => (
                            <option key={key} value={i.type_std_id}>
                              ภาค {i.type_std_name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="select-mj1" className="form-label">
                        คณะ
                      </label>
                      <select
                        id="select-mj1"
                        className="form-control"
                        name="faculty2"
                        onChange={onChangeFac2}
                      >
                        <option>---เลือกคณะที่ต้องการ---</option>
                        {Array.isArray(DataFac2) &&
                          DataFac2.map((i, key) =>
                            i.value !== "8" ? (
                              i.value !== "2" ? (
                                <>
                                  <option key={key} value={i.value}>
                                    {i.label}
                                  </option>
                                </>
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )
                          )}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="select-mj1" className="form-label">
                        สาขาวิชา/วิชาเอก
                      </label>
                      <select
                        required
                        id="select-mj1"
                        className="form-control"
                        name="majorid2"
                        onChange={onChangeMaj2}
                      >
                        <option>---เลือกสาขาวิชา---</option>
                        {Array.isArray(DataMaj2) &&
                          DataMaj2.map((i, key) => (
                            <option key={key} value={i.value}>
                              {i.label} (
                              {i.value.split(",")[1] !== "ควบระดับปริญญาตรีสองปริญญา"
                                ? i.value.split(",")[1]
                                : ""}
                              )
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}

          <div className="m-0  row d-flex justify-content-end pr-3">
            <Button
              iconBefore={<FaFloppyDisk />}
              appearance="primary"
              intent="success"
              type="submit"
              isLoading={IsLoading}
              // disabled={InputRegist.majorid !== "" ? (Chkkb === "ครุศาสตรบัณฑิต"  ? (InputRegist.majorid2 !== ""? true:false):false): true}
              disabled={
                InputRegist.majorid === ""
                  ? true
                  : InputRegist.faculty === "2" ||
                    InputRegist.majorid === "1110" ||
                    InputRegist.majorid === "1310" ||
                    InputRegist.majorid === "1304" ||
                    (InputRegist.faculty === "3" &&
                      (InputRegist.majorid === "1301" || InputRegist.majorid === "1302")) ||
                    (InputRegist.faculty === "1" &&
                      (InputRegist.majorid === "1101" ||
                        InputRegist.majorid === "1110" ||
                        InputRegist.majorid === "1102" ||
                        InputRegist.majorid === "1103" ||
                        InputRegist.majorid === "1110" ||
                        InputRegist.majorid === "1110"))
                    ? (InputRegist.majorid2 === "" && openb === true)
                      ? true
                      : false
                    : false
              }
            // onClick={onSubmit}
            >
              บันทึก
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormRegisterB;


